import { createContext } from 'react';
export const SiteContext = createContext({ website: null });
